export default __webpack_public_path__ + "static/FluoFoundationEmblem-60e00f713efe65bcd6441867f0b00831.png";